export default {
  mapForm: {
    placesAndDirections: 'Găsiți & plecați',
    isochrones: 'Ajungeți la',
    uploadedContentRendered: 'Conținutul încărcat a fost redat',
    errorRenderingContentUploaded: 'Eroare la redarea conținutului încărcat. Verificați formatul și conținutul fișierului',
  }
}
